<template>
  <section id="attractions">
    <div class="center-container">
      <div class="content">
        <div class="attraction-item">
          <h3>Piscina</h3>
          <img src="../assets/img/attractions-pool.jpg" alt="Piscina">
        </div>
        <div class="attraction-item">
          <h3>Salão de Jogos</h3>
          <img src="../assets/img/attractions-salon.jpg" alt="Salão de Jogos">
        </div>
        <div class="attraction-item">
          <h3>Churrasqueiras</h3>
          <img v-lazy="require('../assets/img/attractions-churras.jpg')" alt="Churrasqueiras">
        </div>
        <div class="attraction-item">
          <h3>Campo de Futebol</h3>
          <img v-lazy="require('../assets/img/attractions-field.jpg')" alt="Campo de Futebol">
        </div>
        <div class="attraction-item">
          <h3>Lagos para Pesca</h3>
          <img v-lazy="require('../assets/img/attractions-fishing.jpg')" alt="Lagos para pesca">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Attractions'
}
</script>
